import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './button.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { externalLinkHoverText, isExternalUrl, leavingSiteAlertHandler, renderIcon } from '../../utils/link.js';
import { ifDefined } from 'lit/directives/if-defined';
import { fetchTitle } from "../../utils/dom";

// WCs
import '../icon/icon';

export default class Button extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      disabled: { type: Boolean },
      flexible: { type: Boolean },
      href: { type: String },
      icon: { type: String },
      target: { type: String },
      gtm: { type: String },
      ariaLabel: { type: String },
      /**
       * Icon styleclass to alter the button's icon
       */
      iconStyleclass: { type: String },
      ignoreExternalUrl: { type: Boolean },
      /**
       * Different visual styles
       * @type {primary|primary-lg|secondary|tertiary|compact|image-nav|image-nav-secondary|menu}
       */
      type: { type: String },
    };
  }

  constructor() {
    super();
    this.target = undefined;
    this.type = 'primary';
    this.disabled = false;
    this.icon = 'arrow-right';
    this.iconStyleclass = '';
    this.title = '';
    this.ignoreExternalUrl = false;
  }

  firstUpdated() {
    this.externalUrl = isExternalUrl(this.href)
    this.title = fetchTitle(this).trim()
    this.gtm = this.gtm?.trim()
    this.requestUpdate()
  }

  onClick(event) {
    // Trigger gtm if available
    if (this.gtm) {
      dataLayer.push({
        'event': this.gtm,
      });
      console.log("GTM triggered :" + this.gtm);
    }

    if (this.externalUrl && !leavingSiteAlertHandler()) {
      event.preventDefault()
    }
  }

  render() {
    const classes = classMap({
      btn: true,
      [`btn--${this.type}`]: true,
      'btn--external': this.externalUrl,
    });
    const inner = html`
      <slot></slot>
      <hf-icon
        name="${this.icon}"
        styleclass="${this.iconStyleclass}"
        class="btn__icon"
      >
      </hf-icon>
    `;
    return this.href === undefined
      ? html`
          <button ?disabled=${this.disabled} class="${classes}" @click="${this.onClick}" aria-label="${this.ariaLabel}">
            ${inner}
          </button>
        `
      : html`
          <a
            target="${ifDefined(this.target ? this.target : undefined)}"
            @click="${this.onClick}"
            title="${ifDefined(isExternalUrl(this.href) ? externalLinkHoverText(this.title) : this.title)}"
            href="${this.href}"
            class="${classes}"
          >
            ${inner}
            ${renderIcon(this.href, this.ignoreExternalUrl)}
          </a>
        `;
  }
}
customElements.define('hf-button', Button);
